<template>
  <div class="py-4 container-fluid">
    <!-- Header -->
    <div class="row mb-4 justify-content-between">
      <div class="col-auto">
        <h4 class="fw-bold">Payroll Records</h4>
      </div>
    </div>

    <!-- Payroll Table -->
    <div class="card shadow-sm">
      <div class="card-header pb-0">
        <h6 class="mb-0">Employee Payroll Details</h6>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Client
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Payroll Start
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Payroll End
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Amount
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Net Pay
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Deductions
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7"
                >
                  Paystub
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payroll" :key="item.id">
                <td>
                  <h6 class="mb-0 text-sm fw-bold">
                    {{ item.client?.first_name }} {{ item.client?.last_name }}
                  </h6>
                </td>
                <td>
                  <p class="mb-0 text-sm">{{ item.payroll_start }}</p>
                </td>
                <td>
                  <p class="mb-0 text-sm">{{ item.payroll_end }}</p>
                </td>
                <td>
                  <p class="mb-0 text-sm">${{ item.payroll_amount }}</p>
                </td>
                <td>
                  <p class="mb-0 text-sm">${{ item.net_pay }}</p>
                </td>
                <td>
                  <p class="mb-0 text-sm">${{ item.deductions }}</p>
                </td>
                <td class="align-middle text-center">
                  <soft-button
                    v-if="item.payroll_file"
                    color="info"
                    size="sm"
                    @click="downloadFile(item.payroll_file.split('|')[0])"
                  >
                    Download
                  </soft-button>
                  <span v-else class="text-secondary text-sm">Not available</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import axios from "axios";

export default {
  name: "PayrollView",
  components: { SoftButton },
  data() {
    return {
      payroll: [],
    };
  },
  methods: {
    async fetchPayroll() {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/payroll`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        this.payroll = response.data.payroll;
      } catch (error) {
        console.error("Error fetching payroll:", error);
      }
    },
    downloadFile(fileUrl) {
      axios({
        url: fileUrl, // S3 public link
        method: "GET",
        responseType: "blob", // Important for binary data
      })
        .then((response) => {
          const blob = new Blob([response.data]);
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(fileUrl.split("/").pop()); // Extract filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Download error:", error);
        });
    },
  },
  mounted() {
    this.fetchPayroll();
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
}
.table th {
  font-size: 0.75rem;
}
.table td {
  font-size: 0.85rem;
}
</style>
